import React from 'react';
import { Link } from 'react-router-dom';
import { Tag, Typography } from 'antd';
import { ColumnProps } from 'antd/lib/table';

import { AwsSalesOrderLine } from '@totem/components/administration/amazonWebServices/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';

const { Text } = Typography;

const statusColor = (status: string) =>
  status === 'Active' ? 'green' : 'default';

type Props = {
  salesOrders: AwsSalesOrderLine[];
};

const InstanceSalesOrdersTable = ({ salesOrders }: Props) => {
  if (salesOrders.length === 0) {
    return (
      <Text type="secondary">
        No sales orders assigned — this instance may not be tied to a delivered
        service.
      </Text>
    );
  }

  const columns: ColumnProps<AwsSalesOrderLine>[] = [
    {
      title: 'Sales Order',
      key: 'salesOrderNumber',
      render: (_, record) => (
        <Link
          to={`/dashboard/salesOrder/${encodeURIComponent(record.salesOrderNumber)}`}
        >
          {record.salesOrderNumber}
        </Link>
      ),
    },
    {
      title: 'Line',
      key: 'lineNumber',
      width: 80,
      render: (_, record) => <span>{record.lineNumber}</span>,
    },
    {
      title: 'Service',
      key: 'service',
      render: (_, record) => <span>{record.service}</span>,
    },
    {
      title: 'Status',
      key: 'status',
      width: 100,
      render: (_, record) => (
        <Tag color={statusColor(record.status)}>{record.status}</Tag>
      ),
    },
  ];

  return (
    <IBTable
      rowKey={(record) =>
        `${record.salesOrderId}_${record.lineNumber}_${record.service}`
      }
      columns={columns}
      dataSource={salesOrders}
      pagination={false}
    />
  );
};

export default InstanceSalesOrdersTable;
